<template>
    <div class="m_pay">
       <!-- 头部 -->
       <div class="m_header">
            <div class="header-icon">
                <!-- <i class="iconfont icon-shouyintai"></i> -->
                <img src="../../assets/images/logo.png" alt="" width="30" height="30">
            </div>
            <div class="header-left" >
                嘉贸
            </div>
            <div class="header_ce"></div>
            <div class="header-right">收银台</div>
       </div>
       <!-- 中间支付部分 -->
       <div class="m_main">
            
            <!-- 剩余时间 -->
            <div class="countDown">
                <div class="top">待支付</div>
                <div class="price"><span>￥</span>{{ userInfo.orderSum ? userInfo.orderSum/100:0.00 }}</div>
                <div class="countDown-bottom">
                    <span>剩余时间：</span>
                    <van-count-down v-if="showCount" :time="time" @finish="timeFinish" />
                </div>
             
            </div>
            <!--  -->
             <div class="geren" v-if="userInfo.userCode=='003'">
                <div class="consigneeInfo">
                    <div class="left"></div>
                    <div class="right">
                        <van-radio-group v-model="form.type" direction="horizontal">
                            <van-radio name="1" checked-color="#013372">个人</van-radio>
                            <van-radio name="2" checked-color="#013372">企业</van-radio>
                        </van-radio-group>
                    </div>
                </div>
            </div>
            
            <!-- 企业名称 -->
            <div class="companyName" v-if="form.type=='2'">
                <div class="consigneeInfo">
                    <div class="left"><span style="color:red">*</span>企业名称：</div>
                    <div class="right">
                        <el-input v-model="form.companyName" placeholder="请输入企业名称"></el-input>
                    </div>
                </div>
            </div>
            <!-- 法定代表人/委托代理人 -->
            <div class="entrustedAgent" v-if="form.type=='2'">
                <div class="consigneeInfo">
                    <div class="left"><span style="color:red">*</span>法定代表人：</div>
                    <div class="right">
                        <el-input v-model="form.entrustedAgent" placeholder="请输入法定代表人/委托代理人"></el-input>
                    </div>
                </div>
            </div>
            <div class="entrustedAgent" v-else>
                <div class="consigneeInfo">
                    <div class="left"><span style="color:red">*</span>姓名：</div>
                    <div class="right">
                        <el-input v-model="form.entrustedAgent" placeholder="请输入姓名"></el-input>
                    </div>
                </div>
            </div>
            <div class="email">
                <div class="consigneeInfo">
                    <div class="left"><span style="color:red">*</span>邮箱：</div>
                    <div class="right">
                        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                    </div>
                </div>
            </div>
            <div class="phoneNumber">
                <div class="consigneeInfo">
                    <div class="left">手机号：</div>
                    <div class="right">
                        <el-input v-model="form.phoneNumber" placeholder="请输入手机号"></el-input>
                    </div>
                </div>
            </div>
           <div class="detail">
                <div class="consigneeInfo">
                     <div class="left"></div>
                        <div class="right">
                            <span>采集*相关信息用于生成《委托代收货款协议》</span>
                        </div>
                </div>
                  
                
            </div>
            <!-- 备注 -->
            <!-- <div class="shouhuoInfo">
              
                <div class="consigneeInfo">
                    <div class="left">备注：</div>
                    <div class="right">
                      <div>上海市普陀区金沙江路 1518 弄是的是的所所多多所所所所所所所所</div>
                    </div>
                </div>
             
            </div> -->
            <!-- 协议 -->
            <div class="checkbox">
                <van-checkbox v-model="checked" icon-size="15px"> 
                    阅读并同意<el-button @click="clickAgree" type="text" style="color:red;">《委托代收货款协议》</el-button>，本人已仔细核对订单信息无误，确定付款
                </van-checkbox>
            </div>
            <!-- 支付按钮 -->
            <div class="m_button">
                <van-button type="danger" round  @click="pay">立即支付</van-button>
            </div>
       </div>
        <!-- 底部 -->
        <div class="m_bottom">
            <div class="beian">沪ICP备2022031250号</div>
            <div class="companyName">Copyright©2022上海嘉贸供应链管理有限公司 版权所有</div>
        </div>

        <!-- 弹出层 -->

        <van-overlay :show="show" :lock-scroll="false" >
           <div class="dialog">
                <div class="agree">
                    <!-- title -->
                    <div class="agree-title">委托代收协议</div>
                    <!-- 内容 -->
                    <div class="agree-main" @scroll="scrollEvent">
                    <div style="padding: 0 10px" v-if="userInfo.userCode=='002'">
                    <div>甲方（委托方）</div>
                    <div>公司名称：{{ form.companyName }}</div>
                    <div>法定代表人/委托代理人：{{ form.entrustedAgent }}</div>
                    <div>&nbsp;</div>
                    <div>乙方（受托方）</div>
                    <div>公司名称：：上海嘉贸供应链管理有限公司</div>
                    <div>统一社会信用代码: 91310115MA1HB8WE4N</div>
                    <div>法定代表人：李洋洋</div>
                    <div>&nbsp;</div>
                    <div>甲乙双方按照诚实信用原则，依据相关法律、法规的有关规定，经友好协商,就甲方委托乙方代付（制卡）业务货款事宜达成以下条款，共同遵照执行：</div>
                    <div>&nbsp;</div>
                    <p>1.甲方委托乙方代付甲方在办理制卡业务过程中产生的货款，甲方对乙方代付以上货款行为完全认可，由此造成的一切后果甲方自愿承担相应的法律责任；</p>
                    <p>2.甲方所办理业务为企业行为，甲方委托代理人可以代表甲方向乙方提供甲方的联系方式、甲方名称及甲方相关信息，如甲方拒绝提供可能无法使用相关服务。</p>
                    <p>3.若甲方在线使用支付功能或申请开票等涉及结算、开票功能时，需要完成企业资质认证信息、发票抬头、银行卡信息、经办人身份证号和人脸信息，如果拒绝提供可能无法获得支付或发票开具服务，但不影响其他功能与服务的使用。</p>
                    <p>4.甲方及其委托代理人向乙方完成本协议第1条款项转账后,视为甲方履行了办理制卡业务的付款义务，甲乙双方货款结清；</p>
                    <p>5.协议履行中产生的争议由双方协商解决，协商不成的双方有权向乙方所在地人民法院提起诉讼依法解决。</p>
                    <p>6.甲乙双方完全了解并同意上述条款。</p>
                    <div>&nbsp;</div>
                    <div style="display:flex">
                        <span style="flex:1">甲方： {{ form.companyName }}</span>
                        <span style="flex:1">乙方：上海嘉贸供应链管理有限公司</span>
                    </div>
                    <div style="display:flex">
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                    </div>
                    </div>
                    <div style="padding: 0 10px" v-if="form.type=='2'&&userInfo.userCode=='003'">
                    <div>生效日期：{{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</div>
                    <div>甲方（委托方）</div>
                    <div>公司名称: {{ form.companyName }}</div>
                    <div>法定代表人/委托代理人：{{ form.entrustedAgent }}</div>
                    <!-- <div>联系电话：{{ form.phoneNumber }}</div>
                    <div>电子邮箱：{{ form.email }}</div> -->
                    <div>&nbsp;</div>
                    <div>乙方（受托方）</div>
                    <div>公司名称: 上海嘉贸供应链管理有限公司</div>
                    <div>注册地址: 上海市浦东新区航头镇航都路18号1幢421室 </div>
                    <div>联系电话：021-54363670</div>
                    <p>&nbsp;</p>
                    <div>鉴于，甲方在注册页面上点击“同意”表示同意委托乙方代付业务款项，并经双方友好协商，达成如下协议：</div>
                    <!-- <div>&nbsp;</div> -->
                    <p>一、委托代付业务款项</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲方委托乙方代付业务过程中产生的业务款项，甲方对乙方代付以上业务款项行为完全认可，由此造成的一切后果甲方自愿承担相应的法律责任。</p>
                    <p>&nbsp;&nbsp; 2、 甲方所办理企业及个人业务，甲方委托乙方代理人提供甲方的联系方式、姓名及相关信息，如甲方拒绝提供可能无法使用相关服务。</p>
                    <p>&nbsp;&nbsp; 3、 若甲方在线使用支付功能或申请开票等涉及结算、开票功能时，需要完成身份信息认证、发票抬头、银行卡信息，如果拒绝提供可能无法获得支付或发票开具服务，但不影响其他功能与服务的使用。</p>
                    <p>&nbsp;&nbsp; 4、 甲方及其委托代理人向乙方完成本协议第1条款项转账后，视为甲方履行了办理业务的付款义务，甲乙双方款项结清。</p>
                    <div>&nbsp;</div>
                    <p>二、争议解决</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 协议履行中产生的争议由双方协商解决，协商不成的，双方有权向乙方所在地人民法院提起诉讼依法解决。</p>
                    <div>&nbsp;</div>
                    <p>三、其他条款</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲乙双方完全了解并同意上述条款。</p>
                    <div>&nbsp;</div>
                    <div style="display:flex">
                        <span style="flex:1">甲方： {{ form.companyName }}</span>
                        <span style="flex:1">乙方：上海嘉贸供应链管理有限公司</span>
                    </div>
                    <div style="display:flex">
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                    </div>
                </div>
                <div style="padding: 0 10px" v-if="form.type=='1'&&userInfo.userCode=='003'">
                    <div>生效日期：{{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</div>
                    <div>甲方（委托方）</div>
                    <div>用户姓名：{{ form.entrustedAgent }}</div>
                    <!-- <div>联系电话：{{ form.phoneNumber }}</div>
                    <div>电子邮箱：{{ form.email }}</div> -->
                    <div>&nbsp;</div>
                    <div>乙方（受托方）</div>
                    <div>公司名称: 上海嘉贸供应链管理有限公司</div>
                    <div>注册地址: 上海市浦东新区航头镇航都路18号1幢421室 </div>
                    <div>联系电话：021-54363670</div>
                    <p>&nbsp;</p>
                    <div>鉴于，甲方在注册页面上点击“同意”表示同意委托乙方代付业务款项，并经双方友好协商，达成如下协议：</div>
                    <!-- <div>&nbsp;</div> -->
                    <p>一、委托代付业务款项</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲方委托乙方代付业务过程中产生的业务款项，甲方对乙方代付以上业务款项行为完全认可，由此造成的一切后果甲方自愿承担相应的法律责任。</p>
                    <p>&nbsp;&nbsp; 2、 甲方所办理企业及个人业务，甲方委托乙方代理人提供甲方的联系方式、姓名及相关信息，如甲方拒绝提供可能无法使用相关服务。</p>
                    <p>&nbsp;&nbsp; 3、 若甲方在线使用支付功能或申请开票等涉及结算、开票功能时，需要完成身份信息认证、发票抬头、银行卡信息，如果拒绝提供可能无法获得支付或发票开具服务，但不影响其他功能与服务的使用。</p>
                    <p>&nbsp;&nbsp; 4、 甲方及其委托代理人向乙方完成本协议第1条款项转账后，视为甲方履行了办理业务的付款义务，甲乙双方款项结清。</p>
                    <div>&nbsp;</div>
                    <p>二、争议解决</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 协议履行中产生的争议由双方协商解决，协商不成的，双方有权向乙方所在地人民法院提起诉讼依法解决。</p>
                    <div>&nbsp;</div>
                    <p>三、其他条款</p>
                    <!-- <div>&nbsp;</div> -->
                    <p>&nbsp;&nbsp; 1、 甲乙双方完全了解并同意上述条款。</p>
                    <div>&nbsp;</div>
                    <div style="display:flex">
                        <span style="flex:1">甲方： {{ form.entrustedAgent }}</span>
                        <span style="flex:1">乙方：上海嘉贸供应链管理有限公司</span>
                    </div>
                    <div style="display:flex">
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                        <span style="flex:1">日期: {{ new Date().getFullYear()}}年 {{ new Date().getMonth()+1}}月 {{ new Date().getDate()}}日</span>
                    </div>
                </div>
                
                        
                    </div>
                    <!-- btn -->
                    <div class="agree-btn">
                        <van-button round  type="default" @click="noAgree">不同意</van-button>
                        <van-button round  :disabled="disabled" type="danger" @click="agree">同意</van-button>
                    </div>
                </div>
           </div>
        </van-overlay>

        <!-- 选择支付方式 -->
        <van-action-sheet v-model="showPayDialog"  cancel-text="取消" close-on-click-action @cancel="onCancel">
            <div class="alipay-item" @click="clickPay('alipay')">
                <i class="iconfont icon-alipay"></i>
                支付宝支付
            </div>
            <div class="wxpay-item" @click="clickPay('wxpay')">
                <i class="iconfont icon-wxpay"></i>
                微信扫码支付
            </div>
        </van-action-sheet>
        <!-- 找不到订单的dialog -->
        <van-overlay :show="showErrordialog">
            <div class="errorView">
                <div class="title">提示</div>
                <div class="main">未查找到此单号</div>

                <div class="bottom">
                    <van-button round type="danger" @click="goBack">关闭当前页面</van-button>
                </div>
            </div>
        </van-overlay>
        <!-- wx 二维码 -->
        <van-overlay :show="showWXdialog"> 
            <div class="wx_">
                <div class="wxpay">
                    <img :src="QRImgUrl" />
                    <p>长按识别二维码支付</p>
                    <div class="bottom">
                        <van-button round type="primary" @click="goBack">返回首页</van-button>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!--支付超时 -->
        <van-overlay :show="showTimeOutDialog">
            <div class="timeOut">
                <div class="main">该笔订单已超时!!!</div>
                <div class="bottom">
                    <van-button round type="danger" @click="goBack">返回首页</van-button>
                </div>
            </div>
        </van-overlay>
      
    </div>
</template>

<script>
import '../../style/move.less'
import { reqCommonPay } from '../../api/pay'
import { decrypt } from '@/utils/AES.js'
import { getConfigKey } from '../../api/getCache'
import qrcode from 'qrcode'
export default {
   data(){
    return {
        show:false,
        disabled:true,
        time: 30 * 60 * 1000,
        checked:false,
        showPayDialog:false,
        payUrl:null,
        wxCode:null,
        showCount:true,
        form:{
            type:'2',
            email:'',
            phoneNumber:'',
            companyName:'',
            entrustedAgent:''
        },
        userInfo:{},
        T: '',//定时器的ID
        showErrordialog:false,
        showWXdialog:false,
        showTimeOutDialog:false,
        QRImgUrl:''
    }
   },
   created(){
       if (location.search) {
           // console.log(decodeURIComponent(location.search));
           let code = decodeURIComponent(location.search)
           // let newCode = code.slice(1).replace(/\s/g, '+')

           // let code1 = JSON.parse(decrypt(code))
           // console.log(code.slice(1));
           this.getOrderInfo(decrypt(code.slice(1)))
       } else {
           // 404
          
           this.showErrordialog=true
           this.showCount = false
       }
   },
   mounted(){
      
   },
   methods:{
       goBack(){
           if (this.userInfo.returnWebUrl) {
               // window.history.replaceState(this.userInfo.returnWebUrl)
               // window.location.replace = this.userInfo.returnWebUrl
               let path = window.location.protocol + '//' + this.userInfo.returnWebUrl
               window.location.replace(path)
           } else {
               this.$router.go(-1)
           }
       },
       loopOrderState() {
           this.T = setInterval(async () => {
               const res = await getConfigKey(this.userInfo.orderNo)
               console.log(res);
               if (res.data.result) {
                   this.$toast.success('支付成功');
                   this.goBack()
                   clearInterval(this.T)
                 

               }
           }, 1000)
       },
       async getOrderInfo(code) {
           // console.log(code);
           const res = await reqCommonPay({ orderNo: code },'002')
           // console.log(res);
           if (res.data.code == 500) {
               this.showErrordialog = true
               this.showCount = false
           } else {
               this.userInfo = res.data.result
           }

       },
 
  
       randomString(randomLen, min, max) {
           var str = "",
               range = min,
               arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
                   'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
                   'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
                   'w', 'x', 'y', 'z'];
           // 随机产生
           if (randomLen) {
               range = Math.round(Math.random() * (max - min)) + min;
           }
           for (var i = 0; i < range; i++) {
               let pos = Math.round(Math.random() * (arr.length - 1));
               str += arr[pos];
           }
           return str;
       },
       async clickPay(name){
            // console.log(name)
            if(this.form.type=='1'){
               this.form.companyName='' 
            }
            if(name=='alipay') {
                this.loopOrderState()
                if (this.form.phoneNumber) {
                    // 支付宝
                    const res = await reqCommonPay({
                        payChannel: 1406,
                        orderNo: this.userInfo.orderNo,
                        payEmail: this.form.email,
                        payPhone: this.form.phoneNumber,
                        payName: this.form.entrustedAgent,
                        company: this.form.companyName

                    },this.userInfo.userCode)
                    // console.log(res);
                    let div = document.createElement('div')
                    div.innerHTML = res.data.result.code_url
                    document.body.appendChild(div)
                    document.forms[0].submit()
                }else {
                    // 支付宝
                    const res = await reqCommonPay({
                        payChannel: 1406,
                        orderNo: this.userInfo.orderNo,
                        payEmail: this.form.email,
                       
                        payName: this.form.entrustedAgent,
                        company: this.form.companyName

                    },this.userInfo.userCode)
                    // console.log(res);
                    let div = document.createElement('div')
                    div.innerHTML = res.data.result.code_url
                    document.body.appendChild(div)
                    document.forms[0].submit()
                }
               
               

            }else {
                this.loopOrderState()
                // 微信                                                                                                                                                                                                                                                                                                                      
                if (this.form.phoneNumber) {
                    // 输入了手机号
                    const res = await reqCommonPay({
                        payChannel: 1401,
                        orderNo: this.userInfo.orderNo,
                        payEmail: this.form.email,
                        payPhone: this.form.phoneNumber,
                        payName: this.form.entrustedAgent,
                        company: this.form.companyName
                        // payAmt: 1,
                        // payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                        // orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                        // returnUrl: 'www.baidu.com',
                        // returnWebUrl: 'www.baidu.com',
                        // notes: '制卡以及物流费'
                    },this.userInfo.userCode)

                    if (res.data.code == 200 && res.data.result !== null) {
                        // console.log(res.data.result.code_url);
                        let wxcode = res.data.result.code_url
                        this.showWXdialog = true
                        this.$nextTick(() => {
                            qrcode.toDataURL(wxcode, { errorCorrectionLevel: 'L', margin: 2, width: 200 }, (err, url) => {
                                if (err) throw err
                                this.QRImgUrl = url
                            })
                        })
                       
                      
                    } else {
                        this.$toast.fail('支付失败');
                        
                    }



                }else {
                    // 没输手机号

                    const res = await reqCommonPay({
                        payChannel: 1401,
                        orderNo: this.userInfo.orderNo,
                        payEmail: this.form.email,

                        payName: this.form.entrustedAgent,
                        company: this.form.companyName

                        // payAmt: 1,
                        // payOrderId: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                        // orderNo: moment().format('YYYYMMDDHHmmss') + this.randomString(false, 10),
                        // returnUrl: 'www.baidu.com',
                        // returnWebUrl: 'www.baidu.com',
                        // notes: '制卡以及物流费'
                    },this.userInfo.userCode)

                    if (res.data.code == 200 && res.data.result !== null) {
                        // console.log(res.data.result.code_url);
                        let wxcode = res.data.result.code_url
                        this.showWXdialog = true
                        this.$nextTick(() => {
                            qrcode.toDataURL(wxcode, { errorCorrectionLevel: 'L', margin: 2, width: 200 }, (err, url) => {
                                if (err) throw err
                                this.QRImgUrl = url
                            })
                        })


                    } else {
                        this.$toast.fail('支付失败');

                    }
                }
              
            }
           this.showPayDialog=false
       },
    // 
       onCancel(){
           this.showPayDialog=false
       },
    // 点击支付
       pay(){
            if(this.form.type=='1'){
                if (this.form.entrustedAgent == '' || !this.form.entrustedAgent){
                    return this.$toast('请输入姓名')
                }else if(this.form.email==''|| !this.form.email) {
                    return this.$toast('请输入邮箱')
                } else if (!this.checked) {
                    return this.$toast('请先勾选协议');
                }  
                // 判断邮箱是否正确
                let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
                let isok = reg.test(this.form.email);
                if(!isok){
                    return this.$toast('请输入正确的邮箱')
                }
                if (this.form.phoneNumber && this.form.phoneNumber !== '') {
                    let reg = /^1\d{10}$/
                    let isok = reg.test(this.form.phoneNumber);
                    if (!isok) {
                        return this.$toast('请输入正确的手机号')
                    }
                }
                //    console.log('支付')
                this.showPayDialog=true
            }else {
                 if (this.form.companyName == '' || !this.form.companyName) {
                    return this.$toast('请输入企业名称')
                }else if (this.form.entrustedAgent == '' || !this.form.entrustedAgent){
                    return this.$toast('请输入法定代表人/委托代理人')
                }else if(this.form.email==''|| !this.form.email) {
                    return this.$toast('请输入邮箱')
                } else if (!this.checked) {
                    return this.$toast('请先勾选协议');
                }  
                // 判断邮箱是否正确
                let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
                let isok = reg.test(this.form.email);
                if(!isok){
                    return this.$toast('请输入正确的邮箱')
                }
                if (this.form.phoneNumber && this.form.phoneNumber !== '') {
                    let reg = /^1\d{10}$/
                    let isok = reg.test(this.form.phoneNumber);
                    if (!isok) {
                        return this.$toast('请输入正确的手机号')
                    }
                }
                //    console.log('支付')
                this.showPayDialog=true
            }
        
           
       },
        //点击协议
       clickAgree(){
            this.show=true
       },
       // 当滚动条到底的时候
       scrollEvent(event) {
           let el = event.target;
           if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
               // console.log('到底啦');
               this.disabled = false
           }
       },
    // 同意
       agree(){
           this.show = false
           this.checked=true
       },
    // 不同意
       noAgree(){
            this.show=false
           this.checked=false
       },
       // 倒计时结束触发
       timeFinish() {
           console.log('结束')
           this.showTimeOutDialog=true
       }
   },
    beforeDestroy() {
        clearInterval(this.T)
    }
}
</script>

<style>

</style>